<script>
import useSharedData from "@/use/SharedData";
import {ref} from "vue";
import useValidation from "@/use/Validation";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export default {
    props: {
        pay_day_advance: Boolean,
    },
    setup() {
        const {mxRules} = useValidation();
        const {dialog, loading} = useSharedData();
        const {getBack} = useSharedMethod();
        const {$refs, $route} = useTools();
        const month = ref(null);

        function report() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.post(`/debts/report/${$route.params.id}/${month.value}`).finally(() => {
                    loading.value = false;
                    getBack();
                });
            }
        }

        return {
            mxRules,
            dialog,
            loading,
            month,
            getBack,
            report
        }
    }
};
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="500"
    >
        <v-card>
            <w-toolbar color="cyan" :title="$t('debts.report')"/>
            <v-divider/>
            <v-card-text>
                <v-container fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row justify="center" align="center">
                            <v-col cols="12">
                                <w-label :label="$t('common.month')" required/>
                                <w-month-picker
                                    v-model="month"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn
                    :loading="loading"
                    color="cyan"
                    icon="mdi-pinwheel"
                    :text="$t('common.report')"
                    @press="report"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>